// https://vuex.vuejs.org/en/state.html
/* eslint no-param-reassign : 0 */
export default {
  isLoaded: false,
  classifications: [],
  classification: {},
  state: null,
};
